const TermsStatusEnum = Object.freeze({
    DRAFT: 'DRAFT',
    APPROVED: 'APPROVED',
    SUPERCEDED: 'SUPERCEDED'
});

export default TermsStatusEnum;
